export default "* Hvilke sanser skal vi særligt bruge i denne leg?\n* Hvordan kan man liste lydløst?\n";